
import { Vue, Component } from 'vue-property-decorator'
import {
    DataDTO, statisticByGoodsName, statisticByGoodsNameTop10,
    statisticByGoodsBrand, statisticByGoodsBrandTop10, statisticByGoodsCategory, statisticByGoodsCategoryTop10,
    statisticByArea, statisticByDept, statisticByAreaTop10, statisticByDeptTop10,
} from '@/api/dataReport'
import { exportFileWithData } from '@/utils/h5ToApp'
import DataSelect from '@/views/dataReport/template/dataSelect.vue'
import dayjs from 'dayjs'
import { Chart } from '@antv/g2'
import { moneyFormat, handlePercentage } from '@/utils/util'
import LineListCard from '@/views/dataReport/template/lineListCard.vue'
import TypeProp from '@/views/dataReport/template/TypeProp.vue'
import { Getter } from 'vuex-class'
import AreaPopup from '@/views/dataReport/template/AddrPopup.vue'
import { GetOrganizationInfoAll } from '@/api/customerManage'
import { colors } from '../chartColors'

@Component({
    name: 'AreaGoodsReport',
    components: {DataSelect, LineListCard, TypeProp, AreaPopup}
})
export default class AreaGoodsReport extends Vue {
    @Getter companyId!: string
    readonly format = 'YYYY-MM-DD'
    moneyFormat = moneyFormat
    handlePercentage = handlePercentage
    colors = colors
    loading = false
    finished = false
    refreshing = false
    legendMore = false
    deptName = '部门'
    sortName = '排列方式'
    goodsName = '商品'

    statisticOptions = [
        {text: '按区域统计', value: 'area'},
        {text: '按部门统计', value: 'dept'}
    ]
    showStatistic = false

    // 部门选择数据
    depList = []
    showDept = false

    // 订单排行方式
    sortTypeOption = [
        {text: '订货单数量排行', value: '1'},
        {text: '退货单数量排行', value: '2'},
        {text: '订货金额排行', value: '3'},
        {text: '退货金额排行', value: '4'}
    ]
    showSort = false

    // 商品统计类型
    goodsTypeOptions = [
        {text: '按商品名称统计', value: '1'},
        {text: '按商品品牌统计', value: '2'},
        {text: '按商品分类统计', value: '3'}
    ]

    showGoodsType = false

    queryParams = {
        startDate: dayjs().format(this.format),
        endDate: dayjs().format(this.format),
        checkType: '1',//查看方式,'1'按订单查看 '2' 按商品查看
        deptId: '', //部门id
        deptLevelIds: '',//部门级别编号
        orderType: 'desc', // 排序方式 asc:升序, desc:降序
        statisticalSection: 'area', // 统计方式
        statisticalSectionId: '', // 统计区间编号
        areaName: '全部区域', //地区名称
        areaId: '', //读取id
        sortType: '1', //排序字段  1：订货数量2：订货金额3：退货数量4：退货金额5：订货单数量6：退货单数量
        type: '1', // 商品排行方式 1. 按商品统计  2. 按商品分类统计  3. 按商品品牌统计
        hierarchyId: '',// 商品分类层级编号
        pageIndex: 1,
        pageSize: 10
    }

    chartData: DataDTO[] = [] //饼图数据
    chart: Chart | null = null
    list: DataDTO[] = [] //列表数据

    get listType () {
        let type = [
            {
                text: '订货单',
                key: 'orderCount',
            },
            {
                text: '订单收货数量',
                key: 'receiveCount',
            },
            {
                text: '订单收货金额',
                key: 'receiveMoneyCount',
                type: 'money'
            },
            {
                text: '退货单数量',
                key: 'returnOrderCount',
            },
            {
                text: '退单退货数量',
                key: 'returnCount',
            },
            {
                text: '退单退货金额',
                key: 'returnMoneyCount',
                type: 'money'
            }
        ]
        return type
    }

    get topLeft () {
        let key = 'areaName'
        if (this.queryParams.checkType === '1' && this.queryParams.statisticalSection === 'area') { // 按订单查看/地区
            key = 'areaName'
        } else if (this.queryParams.checkType === '1' && this.queryParams.statisticalSection === 'dept') { // 按订单查看/部门
            key = 'deptName'
        }

        if (this.queryParams.checkType === '2' && this.queryParams.type === '1') { // 按商品查看/商品名称
            key = 'goodsName'
        } else if (this.queryParams.checkType === '2' && this.queryParams.type === '2') { // 按商品查看/品牌
            key = 'brandName'
        } else if (this.queryParams.checkType === '2' && this.queryParams.type === '3') { // 按商品查看/分类
            key = 'categoryName'
        }

        return key
    }

    get params () {
        let params: any = {}
        params = {
            startDate: this.queryParams.startDate,
            endDate: this.queryParams.endDate,
            statisticalSection: this.queryParams.statisticalSection,
            hierarchyId: this.queryParams.hierarchyId,
            orderFieldName: this.queryParams.sortType,
            orderType: this.queryParams.orderType,
            pageIndex: this.queryParams.pageIndex,
            pageSize: this.queryParams.pageSize,
            type: this.queryParams.type
        }
        if (this.queryParams.statisticalSection === 'area') {
            Object.assign(params, {statisticalSectionId: this.queryParams.areaId})
        } else if (this.queryParams.statisticalSection === 'dept') {
            Object.assign(params, {statisticalSectionId: this.queryParams.deptId})
        }
        return params
    }

    get goodsTypeText () {
        let text = '商品名称'
        switch (this.queryParams.type + '') {
            case '1':
                text = '商品名称'
                break
            case '2':
                text = '商品品牌'
                break
            case '3':
                text = '商品分类'
                break
            default:
                text = '商品名称'
                break
        }
        return text
    }

    get sortTypeText () {
        let text = '订货单数量'
        switch (this.queryParams.sortType + '') {
            case '1':
                text = '订货单数量'
                break
            case '2':
                text = '退货单数量'
                break
            case '3':
                text = '订货金额'
                break
            case '4':
                text = '退货金额'
                break
        }
        return text
    }

    get sortTypeValue () {
        let text = 'orderCount'
        switch (this.queryParams.sortType + '') {
            case '1':
                text = 'orderCount'
                break
            case '2':
                text = 'returnCount'
                break
            case '3':
                text = 'receiveMoneyCount'
                break
            case '4':
                text = 'returnMoneyCount'
                break
        }
        return text
    }

    created () {
        this.load()
        this.getDepList()
    }

    orderTypeList = [
        {
            text: '按订单统计',
            value: 1
        },
        {
            text: '按商品统计',
            value: 2
        },
    ] // 数据请求方式列表

    mounted () {
        this.initChart()
    }

    load () {
        this.queryParams.pageIndex = 1
        this.finished = false
        this.list = []
        this.getListByGoods()
    }

    /**
     * 初始化饼图
     */
    initChart () {
        const data: any = [
            {name: '', compareValue: 0}
        ]

        const chart = new Chart({
            container: 'goods-chart-container',
            autoFit: true,
            height: 280
        })

        chart.legend(false)

        chart.coordinate('theta', {
            radius: 0.6,
            innerRadius: 0.55
        })

        chart.data(data)

        chart.tooltip({
            showTitle: false,
            showMarkers: false
        })
        chart
            .interval()
            .position('compareValue')
            .color('name', this.colors)
            .label('percentage', (val) => {
                let isLabel = val > 0.2
                if (isLabel) {
                    return {
                        content: (data) => {
                            return `${data.name.length > 5 ? data.name.slice(0, 5) + ' ...' : data.name}:\n ${handlePercentage(data.percentage)}`
                        },
                        style: {
                            fill: '#313131',
                        },
                        layout: {type: 'pie-spider'},
                    }
                }
            })
            .tooltip('name*compareValue', (name, compareValue) => {
                return {
                    name: name,
                    value: compareValue,
                }
            })
            .adjust('stack')

        chart.interaction('element-active')

        chart.render()
        this.chart = chart
    }

    handleChartLabel (text: string) {
        if (text.length >= 5) {
            return text.slice(0, 5) + ' ...'
        } else {
            return text
        }
    }

    /**
     *  区域类型选择完毕
     */
    handleStatisticChange (obj: any) {
        this.showStatistic = false
        this.queryParams.statisticalSection = obj.value
        this.load()
    }

    /**
     *  部门类型选择完毕
     */
    handleDeptChange (obj: any) {
        this.showDept = false
        this.queryParams.deptId = obj.value
        this.deptName = obj.orgName
        this.load()
    }

    /**
     *  排行方式选择完毕
     */
    handleSortChange (obj: any) {
        this.showSort = false
        this.queryParams.sortType = obj.value
        this.sortName = obj.text
        this.load()
    }

    /**
     *  商品统计方式选择完毕
     */
    handleGoodsTypeChange (obj: any) {
        this.showGoodsType = false
        this.queryParams.type = obj.value
        switch (obj.value) {
            case '1':
                this.goodsName = '商品名称'
                break
            case '2':
                this.goodsName = '商品品牌'
                break
            case '3':
                this.goodsName = '商品分类'
                break
            default:
                this.goodsName = '商品名称'
                break
        }
        this.load()
    }


    /**
     * @description: 地区选择弹框打开
     */
    handleShowAreaOrDept () {
        if (this.queryParams.statisticalSection === 'area') {
            (this.$refs.areaPopup as AreaPopup).showPop()
        } else {
            this.showDept = true
        }
    }

    /**
     * 区域选择改变
     * @param addressId
     * @param addressName
     * @param index
     */
    handleAddressChange ({addressId, addressName}) {
        this.queryParams.areaId = addressId
        this.queryParams.areaName = addressName
        this.load()
    }

    /**
     * 获取客户分组列表
     */
    getDepList () {
        GetOrganizationInfoAll({companyId: this.companyId}).then((res: any) => {
            this.depList = res.data
            this.depList.forEach(item => {
                // if (item.isEnabled === '0' || item.orgType === '1') {
                if (item.isEnabled === '0') {
                    item.disabled = true
                }
                item.text = item.orgName
                item.value = item.orgId
            })
            this.queryParams.deptId = this.depList[0].orderId
        })
    }


    /**
     *按商品查看的数据请求
     */
    getListByGoods () {
        let requests = [statisticByGoodsName, statisticByGoodsBrand, statisticByGoodsCategory,]
        let requestTop10s = [statisticByGoodsNameTop10, statisticByGoodsBrandTop10, statisticByGoodsCategoryTop10]

        requests[parseInt(this.queryParams.type) - 1]({
            ...this.params
        }).then(res => {
            this.list = this.list.concat(res.data.records)
            if (this.list.length >= res.data.totalRecords) {
                this.finished = true
            }
            this.queryParams.pageIndex++
        }).finally(() => {
            this.loading = false
            this.refreshing = false
        })
        // 图形数据
        requestTop10s[parseInt(this.queryParams.type) - 1]({
            ...this.params
        }).then(res => {
            this.chartData = res.data
            if (this.chartData.length > 0) {
                this.$nextTick(() => {
                    this.chart!.data(this.chartData)
                    this.chart!.render()
                })
            }
        })
    }

    /**
     * 头部总时间段改变
     * @param value
     */
    handleDataChange (value: Array<string>) {
        this.queryParams.startDate = value[0]
        this.queryParams.endDate = value[1]
        this.queryParams.startDate = value[0]
        this.queryParams.endDate = value[1]
        this.load()
    }


    /**
     * 导出数据
     */
    handleExport () {
        exportFileWithData({
            method: 'post',
            portUrl: '/cykjreport/RegionalByCommodity/exportAreaGoods',
            params: JSON.stringify(Object.assign({companyId: this.companyId}, {...this.params}))
        })
    }
}
